// extracted by mini-css-extract-plugin
export var addToCartButton = "_ob-b";
export var arrowButtonContainer = "_ob-9";
export var arrowButtonIcon = "_ob-a";
export var carouselArrowButton = "_ob-6";
export var carouselElementContainer = "_ob-1";
export var galleryThumbnail = "_ob-d";
export var galleryThumbnailImage = "_ob-e";
export var left = "_ob-7";
export var productDisplayCarouselContainer = "_ob-0";
export var productTileContainer = "_ob-2";
export var productTileImage = "_ob-4";
export var productTileImageContainer = "_ob-3";
export var productTileTitle = "_ob-5";
export var right = "_ob-8";
export var sliderOverflow = "_ob-c";